import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import each from "lodash/each"
import dayjs from "utils-lib/date"
import {
  GET_CUSTOMER_ACCOUNT_FAILED,
  GET_CUSTOMER_ACCOUNT_PENDING,
  GET_CUSTOMER_ACCOUNT_FULFILLED,
  SET_CUSTOMER_SELECTED_LANGUAGE,
  SET_CUSTOMER_LOB,
  SET_CHECK_AVAILABILITY_LOB,
  SET_SERVICE_ADDRESS_FORM_VARIATION,
  SET_GEOCODE_CUSTOMER_ADDRESS,
  SET_CUSTOMER_ADDRESS,
  SET_MOVING_CUSTOMER_ADDRESS,
  SET_FIRST_NAME,
  RESET_CITY_BILLED_ELIGIBILITY_URL,
  GET_CITY_BILLED_ELIGIBILITY_URL_PENDING,
  GET_CITY_BILLED_ELIGIBILITY_URL_FULFILLED,
  GET_CITY_BILLED_ELIGIBILITY_URL_FAILED,
  SET_LAST_NAME,
  SET_BUSINESS_TYPE,
  SET_APARTMENT_NUMBER,
  GET_ALERTS_ADDRESS_FULFILLED,
  GET_ALERTS_CUSTOMER_ID_FULFILLED,
  GET_ALERTS_USER_ID_FULFILLED,
  GET_INCIDENTS_BY_USER_ID_FULFILLED,
  SET_PRIMARY_ADDRESS,
  SET_USER_STATE,
  SET_ERROR_ON_SUGGEST,
  SET_ERROR_ON_SUGGEST_SCHEDULE,
  GET_PRODUCTS_URL_PENDING,
  GET_PRODUCTS_URL_FULFILLED,
  ADD_REMOVE_CATALOG,
  RESET_CATALOG,
  MOVING_IN,
  SELECTED_DELIVERY_DATE,
  GET_PRODUCTS_CLEAR_STATE,
  GET_PRODUCTS_URL_FAILED,
  GET_COMBINED_PRODUCT_URL_CLEAR_STATE,
  RESET_CUSTOMER_ADDRESS_FROM_STATE,
  GET_COMBINED_PRODUCT_URL_PENDING,
  GET_COMBINED_PRODUCT_URL_FULFILLED,
  GET_COMBINED_PRODUCT_URL_FAILED,
  SHOW_COMBINED_PRODUCT_STATE,
  HIDE_COMBINED_PRODUCT_STATE,
  SET_MODAL_ID,
  SET_MENU_OPEN,
  GET_USER_PAYMENT_STATUS_FULFILLED,
  GET_LINKED_ACCOUNTS_FULFILLED,
  SET_SHOW_MOBILE_SEARCH,
  SET_IS_SUPPORT_TOPIC,
  SET_NO_FRENCH_CONTENT,
  SET_SELECT_AREA_MODAL_CLOSED,
  SET_ALERTS_READ,
  SET_FORM_SUBMITTED,
  SET_ALERTS_SELECTED_ACCOUNT,
  SET_CUSTOMER_ID,
  SET_CUSTOMER_EMAIL,
  SET_CUSTOMER_PHONE,
  SET_CUSTOMER_PRODUCT,
  SET_HAS_GEOSUGGESTION,
  SET_CUSTOMER_SERVICE_TYPE,
  SET_CUSTOMER_CONTACT_US_METHOD,
  SET_RENDER_DASHBOARD,
  RESET_MYSERVICES_DASHBOARD,
  RESET_DASHBOARD_FROM_GETTING_STARTED,
  SET_FIRST_COMPONENT_LOADED,
  GET_ALERTS_ADDRESS_PENDING,
  GET_ALERTS_CUSTOMER_ID_PENDING,
  GET_ALERTS_USER_ID_PENDING,
  GET_ALERTS_ADDRESS_FAILED,
  GET_ALERTS_CUSTOMER_ID_FAILED,
  GET_ALERTS_USER_ID_FAILED,
  CLEAR_GUEST_DATA,
  SET_IS_SEARCH_AGAIN,
  RESET_CUSTOMER_SERVICE_TYPE,
  SET_CUSTOMER_ACCOUNT_SOURCE,
  SET_GUIDED_FLOW_SELECTIONS,
  GET_CONTACT_BACK_ATTRIBUTES_PENDING,
  GET_CONTACT_BACK_ATTRIBUTES_FULFILLED,
  GET_CONTACT_BACK_ATTRIBUTES_FAILED,
  GET_CONTACT_BACK_CASES_PENDING,
  GET_CONTACT_BACK_CASES_FULFILLED,
  GET_CONTACT_BACK_CASES_FAILED,
  GET_ENERGY_SURCHARGE_CALCULATOR_RESULT_PENDING,
  GET_ENERGY_SURCHARGE_CALCULATOR_RESULT_FULFILLED,
  GET_ENERGY_SURCHARGE_CALCULATOR_RESULT_FAILED,
  RESET_ENERGY_SURCHARGE_CALCULATOR_RESULT,
  SET_BUISNESS_HELPMECHOOSE,
  GET_GUEST_CONTAINER_REPAIR_ELIGIBILITY_PENDING,
  GET_GUEST_CONTAINER_REPAIR_ELIGIBILITY_FAILED,
  GET_GUEST_CONTAINER_REPAIR_ELIGIBILITY_FULFILLED,
  RESET_GUEST_CONTAINER_REPAIR,
} from "constants-lib/actionTypes"
import { LINE_OF_BUSINESS, API_STATUSES } from "constants-lib/common"
import { userType } from "constants-lib/authentication"
import { logRocketIdentify } from "utils-lib/logRocket"

export const initialState = {
  cancelService: {
    isMovingFlow: false,
  },
  customerLob: ``,
  serviceAddressFormVariation: ``,
  customerSelectedLob: ``,
  customerSelectedLanguage: null,
  customerProduct: ``,
  customerAddress: {
    formattedAddress: ``,
    label: ``,
    streetNumber: ``,
    streetName: ``,
    county: ``,
    lat: null,
    lng: null,
    city: ``,
    state: ``,
    country: ``,
    postalCode: ``,
    gPlaceId: ``,
  },
  customerSearchedAddress: {
    formattedAddress: ``,
    label: ``,
    streetNumber: ``,
    streetName: ``,
    county: ``,
    lat: null,
    lng: null,
    city: ``,
    state: ``,
    country: ``,
    postalCode: ``,
    gPlaceId: ``,
  },
  firstName: ``,
  lastName: ``,
  apartmentNumber: ``,
  businessType: {
    label: ``,
    industryClassification: ``,
    NAICSCode: ``,
  },
  guidedFlowSelections: {},
  contactBackAttributesStatus: "",
  contactBackAttributesData: {},
  contactBackCasesStatus: "",
  contactBackCasesData: {},
  eligibilityData: {},
  eligibilityErrorInfo: {},
  getEligibilityStatus: ``,
  cityBilledEligibility: {},
  cityBilledEligibilityStatus: ``,
  customerEmail: ``,
  customerId: ``,
  customerPhone: ``,
  customerAccounts: {}, // Search results for customer accounts.
  primaryAddress: ``, // The initial formatted address.
  customerServiceType: `empty`,
  customerContactUsMethod: ``,
  getCustomerAccountState: ``,
  fetchCode: 0,
  customerAccountSource: ``,
  renderDashboard: false,
  showErrorMessage: ``,
  getProductsUrlStatus: ``,
  productSupportData: {},
  getCombinedProductUrlStatus: ``,
  combinedProductSupportData: {},
  showCombinedProduct: false,
  showSuggestError: false,
  showSuggestErrorSchedule: false,
  servicesModal: false,
  modalId: ``,
  isMenuOpen: false,
  userProducts: {},
  alertsSelectedAccount: ``,
  alertsRead: false,
  isSearchAgain: false,
  isAddressSearch: true,
  hasNotifications: false,
  showMobileSearch: false,
  isSupportSearch: false,
  isSupportTopic: false,
  noFrenchContent: false,
  selectAreaModalClosed: false,
  formSubmitted: false,
  businessPickupData: {},
  selectedCatalogs: [],
  selectedTrashService: {},
  selectedTrashFrequency: {},
  selectedTrashQuantity: {},
  selectedRecyclingService: {},
  selectedRecyclingFrequency: {},
  selectedRecycleQuantity: {},
  selectedFoodWasteService: {},
  selectedFoodWasteFrequency: {},
  selectedFoodWasteQuantity: {},
  energySurchargeCalculatorStatus: ``,
  energySurchargeCalculatorResult: 0,
  movingIn: false,
  helpmeChooseBusiness: ``,
  customerAccountSearchState: ``,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_CUSTOMER_ACCOUNT_FAILED:
      return {
        ...state,
        customerAccounts: {},
        getCustomerAccountState: API_STATUSES.FAILED,
        fetchCode: action.payload,
      }

    case GET_CUSTOMER_ACCOUNT_PENDING:
      return {
        ...state,
        customerAccounts: {},
        getCustomerAccountState: API_STATUSES.PENDING,
        renderDashboard: initialState.renderDashboard,
        fetchCode: 0,
        customerAccountSearchState: API_STATUSES.PENDING,
      }

    case GET_CUSTOMER_ACCOUNT_FULFILLED: {
      const userProducts = {}

      each(get(action, `payload.customerAccounts.accounts`, []), (account) => {
        const lob = get(account, `lineOfBusiness`, ``).toUpperCase()

        if (!userProducts.TRO && lob === LINE_OF_BUSINESS.ROLLOFF) {
          userProducts.TRO = true
        }

        if (!userProducts.SMB && lob === LINE_OF_BUSINESS.COMMERCIAL) {
          userProducts.SMB = true
        }

        if (!userProducts.OMR && lob === LINE_OF_BUSINESS.RESIDENTIAL) {
          userProducts.OMR = true
        }
      })

      let newLob = state.customerLob

      if (userProducts.TRO && userProducts.OMR && !userProducts.SMB) {
        newLob = `home`
      } else if (userProducts.TRO || userProducts.SMB) {
        newLob = `business`
      } else if (userProducts.OMR) {
        newLob = `home`
      }

      return {
        ...state,
        customerAccounts: action.payload.customerAccounts,
        getCustomerAccountState: API_STATUSES.FULFILLED,
        fetchCode: 0,
        userProducts,
        customerLob: newLob,
        customerSelectedLob: newLob,
      }
    }

    case SET_CUSTOMER_SELECTED_LANGUAGE:
      return {
        ...state,
        customerSelectedLanguage: action.payload,
      }

    case SET_CUSTOMER_LOB:
      return {
        ...state,
        customerLob: action.payload,
        customerSelectedLob: action.payload,
      }

    case SET_CHECK_AVAILABILITY_LOB:
      return {
        ...state,
        checkAvailabilityLob: action.payload.checkAvailabilityLob,
      }

    case SET_SERVICE_ADDRESS_FORM_VARIATION:
      return {
        ...state,
        serviceAddressFormVariation: action.payload.variationType,
      }

    case SET_GEOCODE_CUSTOMER_ADDRESS: {
      const oldAddress = get(state, `customerAddress`, {})
      const newAddress = get(action, `payload`, {})

      const isSameAddress =
        oldAddress.streetNumber === newAddress.streetNumber &&
        oldAddress.streetName === newAddress.streetName &&
        oldAddress.city === newAddress.city

      return {
        ...state,
        customerAddress: isSameAddress ? state.customerAddress : action.payload,
        customerSearchedAddress:
          isSameAddress ||
          isEmpty(get(state, `customerSearchedAddress.formattedAddress`, ``))
            ? action.payload
            : state.customerSearchedAddress ||
              !get(state, `customerSearchedAddress.formattedAddress`, ``),
        isAddressSearch: false,
      }
    }

    case SET_MOVING_CUSTOMER_ADDRESS:
      return {
        ...state,
        customerAccounts: {},
        getProductsUrlStatus: ``,
        renderDashboard: initialState.renderDashboard,
        customerId: ``,
        isAddressSearch: true,
        customerMovingAddress: action.payload,
      }

    case SET_CUSTOMER_ADDRESS:
      return {
        ...state,
        customerAddress: action.payload || {
          formattedAddress: ``,
          label: ``,
          streetNumber: ``,
          streetName: ``,
          county: ``,
          lat: null,
          lng: null,
          city: ``,
          state: ``,
          country: ``,
          postalCode: ``,
          gPlaceId: ``,
        },
        customerSearchedAddress: action.payload,
        customerAccounts: {},
        getProductsUrlStatus: ``,
        renderDashboard: initialState.renderDashboard,
        customerId: ``,
        isAddressSearch: true,
      }

    case SET_FIRST_NAME:
      return {
        ...state,
        firstName: action.payload || ``,
        businessType: {
          label: ``,
          industryClassification: ``,
          NAICSCode: ``,
        },
      }

    case RESET_CITY_BILLED_ELIGIBILITY_URL:
      return {
        ...state,
        cityBilledEligibility: {},
        cityBilledEligibilityStatus: "",
      }
    case GET_CITY_BILLED_ELIGIBILITY_URL_PENDING:
      return {
        ...state,
        cityBilledEligibilityStatus: API_STATUSES.PENDING,
      }
    case GET_CITY_BILLED_ELIGIBILITY_URL_FULFILLED:
      return {
        ...state,
        cityBilledEligibility: {
          ...action.payload,
          showLoginModal: action.payload?.showLoginModal || false,
        },
        cityBilledEligibilityStatus: API_STATUSES.FULFILLED,
      }

    case GET_CITY_BILLED_ELIGIBILITY_URL_FAILED:
      return {
        ...state,
        cityBilledEligibility: {
          ...action.payload,
        },
        cityBilledEligibilityStatus: API_STATUSES.FAILED,
        hasErrorMessage: true,
      }

    case SET_LAST_NAME:
      return {
        ...state,
        lastName: action.payload || ``,
        businessType: {
          label: ``,
          industryClassification: ``,
          NAICSCode: ``,
        },
      }

    case SET_BUSINESS_TYPE:
      return {
        ...state,
        businessType: action.payload || {
          label: ``,
          industryClassification: ``,
          NAICSCode: ``,
        },
        firstName: ``,
        lastName: ``,
      }

    case SET_APARTMENT_NUMBER:
      return {
        ...state,
        apartmentNumber: action.payload || ``,
        businessType: {
          label: ``,
          industryClassification: ``,
          NAICSCode: ``,
        },
      }

    case GET_ALERTS_ADDRESS_FULFILLED:
    case GET_ALERTS_CUSTOMER_ID_FULFILLED:
    case GET_ALERTS_USER_ID_FULFILLED:
      return {
        ...state,
        alertsRead: action.payload?.isNotificationsPage || false,
        hasNotifications: !isEmpty(action.payload?.notifications),
      }

    case GET_INCIDENTS_BY_USER_ID_FULFILLED: {
      const customers = action.payload.incidents

      const isWithin30Days = getWithin30Days(customers)

      return {
        ...state,
        alertsRead:
          action.payload &&
          (action.payload.isNotificationsPage ||
            (!isWithin30Days && !state.hasNotifications)),
      }
    }

    case SET_PRIMARY_ADDRESS: {
      const primaryAddress = action.payload

      return {
        ...state,
        primaryAddress,
      }
    }

    /* Clear state after logging in. */
    case SET_USER_STATE: {
      if (action.payload === userType.LOGGED_IN) {
        return {
          ...initialState,
          customerAccounts: {},
          customerAddress: state.customerAddress,
          customerSearchedAddress: state.customerSearchedAddress,
          customerLob: state.customerLob,
          customerSelectedLob: state.customerSelectedLob,
          customerSelectedLanguage: state.customerSelectedLanguage,
          guidedFlowSelections: state.guidedFlowSelections,
          businessPickupData: state.businessPickupData,
          modalId: state.modalId,
          selectedCatalogs: state.selectedCatalogs,
        }
      }
      return {
        ...state,
      }
    }

    case SET_ERROR_ON_SUGGEST: {
      return {
        ...state,
        showSuggestError: action.payload,
        getProductsUrlStatus: ``,
      }
    }

    case SET_ERROR_ON_SUGGEST_SCHEDULE: {
      return { ...state, showSuggestErrorSchedule: action.payload }
    }

    case GET_PRODUCTS_URL_PENDING:
      return {
        ...state,
        getProductsUrlStatus: API_STATUSES.PENDING,
        productSupportData: {},
        hasErrorMessage: ``,
        productType: action.productType,
      }

    case GET_PRODUCTS_URL_FULFILLED:
      return {
        ...state,
        getProductsUrlStatus: API_STATUSES.FULFILLED,
        hasErrorMessage:
          !action.payload.renderSupportForm &&
          !action.payload.isCloudCrazeUrlValid,
        productSupportData: action.payload,
        businessPickupData: action.payload.businessPickupData,
        selectedDeliveryDate: "",
      }

    case ADD_REMOVE_CATALOG:
    case RESET_CATALOG: {
      return {
        ...state,
        selectedCatalogs: action.catalog,
      }
    }

    case MOVING_IN: {
      return {
        ...state,
        movingIn: action.movingIn,
      }
    }

    case SELECTED_DELIVERY_DATE: {
      return {
        ...state,
        selectedDeliveryDate: action.date,
      }
    }

    case GET_PRODUCTS_CLEAR_STATE:
      return {
        ...state,
        getProductsUrlStatus: ``,
        productSupportData: {},
        hasErrorMessage: ``,
        combinedProductSupportData: {},
        getCombinedProductUrlStatus: ``,
      }

    case GET_PRODUCTS_URL_FAILED:
      return {
        ...state,
        getProductsUrlStatus: API_STATUSES.FAILED,
        hasErrorMessage: true,
      }

    case GET_COMBINED_PRODUCT_URL_CLEAR_STATE:
      return {
        ...state,
        getCombinedProductUrlStatus: ``,
        combinedProductSupportData: {},
      }

    case GET_COMBINED_PRODUCT_URL_PENDING:
      return {
        ...state,
        getCombinedProductUrlStatus: API_STATUSES.PENDING,
        combinedProductSupportData: {
          // Prevent flashing of select area modal
          localsitesResults: get(
            state,
            `combinedProductSupportData.localsitesResults`,
            [],
          ),
        },
        getProductsUrlStatus: ``,
        productSupportData: {},
        hasErrorMessage: ``,
      }

    case GET_COMBINED_PRODUCT_URL_FULFILLED:
      return {
        ...state,
        getCombinedProductUrlStatus: API_STATUSES.FULFILLED,
        combinedProductSupportData: action.payload,
      }

    case GET_COMBINED_PRODUCT_URL_FAILED:
      return {
        ...state,
        getCombinedProductUrlStatus: API_STATUSES.FAILED,
      }

    case SHOW_COMBINED_PRODUCT_STATE:
      return {
        ...state,
        showCombinedProduct: true,
      }

    case HIDE_COMBINED_PRODUCT_STATE:
      return {
        ...state,
        showCombinedProduct: false,
      }

    case SET_MODAL_ID:
      return {
        ...state,
        modalId: action.payload.modalId,
      }

    case SET_MENU_OPEN:
      return {
        ...state,
        isMenuOpen: action.payload.isMenuOpen,
      }

    case GET_USER_PAYMENT_STATUS_FULFILLED: {
      const userProducts = {}

      each(action.payload, (account) => {
        const lob = get(account, `lineOfBusiness`, ``).toUpperCase()

        if (!userProducts.TRO && lob === LINE_OF_BUSINESS.ROLLOFF) {
          userProducts.TRO = true
        }

        if (!userProducts.SMB && lob === LINE_OF_BUSINESS.COMMERCIAL) {
          userProducts.SMB = true
        }

        if (!userProducts.OMR && lob === LINE_OF_BUSINESS.RESIDENTIAL) {
          userProducts.OMR = true
        }
      })

      let newLob = state.customerLob

      if (userProducts.TRO && userProducts.OMR && !userProducts.SMB) {
        newLob = `home`
      } else if (userProducts.TRO || userProducts.SMB) {
        newLob = `business`
      } else if (userProducts.OMR) {
        newLob = `home`
      }

      return {
        ...state,
        userProducts: isEmpty(userProducts) ? state.userProducts : userProducts,
        customerLob: newLob,
        customerSelectedLob: newLob,
      }
    }

    case GET_LINKED_ACCOUNTS_FULFILLED: {
      const userProducts = {}

      each(action.payload.linkedAccounts, (account) => {
        const lob = get(account, `lob`, ``).toUpperCase()

        if (!userProducts.TRO && lob === LINE_OF_BUSINESS.ROLLOFF) {
          userProducts.TRO = true
        }

        if (!userProducts.SMB && lob === LINE_OF_BUSINESS.COMMERCIAL) {
          userProducts.SMB = true
        }

        if (!userProducts.OMR && lob === LINE_OF_BUSINESS.RESIDENTIAL) {
          userProducts.OMR = true
        }
      })

      let newLob = state.customerLob

      if (userProducts.TRO && userProducts.OMR && !userProducts.SMB) {
        newLob = `home`
      } else if (userProducts.TRO || userProducts.SMB) {
        newLob = `business`
      } else if (userProducts.OMR) {
        newLob = `home`
      }

      return {
        ...state,
        userProducts,
        customerLob: newLob,
        customerSelectedLob: newLob,
      }
    }

    case SET_SHOW_MOBILE_SEARCH:
      return {
        ...state,
        showMobileSearch: action.payload.showMobileSearch,
        isSupportSearch: !!action.payload.isSupportSearch,
      }

    case SET_IS_SUPPORT_TOPIC:
      return {
        ...state,
        isSupportTopic: action.payload.isSupportTopic,
      }

    case SET_NO_FRENCH_CONTENT:
      return {
        ...state,
        noFrenchContent: action.payload.noFrenchContent,
      }

    case SET_SELECT_AREA_MODAL_CLOSED:
      return {
        ...state,
        selectAreaModalClosed: action.payload.selectAreaModalClosed,
      }

    case SET_ALERTS_READ:
      return {
        ...state,
        alertsRead: action.payload.alertsRead,
      }

    case SET_FORM_SUBMITTED:
      return {
        ...state,
        formSubmitted: action.payload.formSubmitted,
      }

    case SET_ALERTS_SELECTED_ACCOUNT:
      return {
        ...state,
        alertsSelectedAccount: action.payload.alertsSelectedAccount,
      }

    case SET_CUSTOMER_ID: {
      const customerId = action.payload

      logRocketIdentify({
        name: `Guest (Customer ID)`,
        customerId,
      })

      return {
        ...state,
        customerId,
      }
    }

    case SET_CUSTOMER_EMAIL: {
      const customerEmail = action.payload

      logRocketIdentify({
        name: `Guest (Email)`,
        email: customerEmail,
      })

      return {
        ...state,
        customerEmail: action.payload,
      }
    }

    case SET_CUSTOMER_PHONE: {
      const customerPhone = action.payload

      logRocketIdentify({
        name: `Guest (Phone)`,
        phone: customerPhone,
      })

      return {
        ...state,
        customerPhone,
      }
    }

    case SET_CUSTOMER_PRODUCT:
      return {
        ...state,
        productSupportData: {},
        customerProduct: action.payload,
      }

    case SET_HAS_GEOSUGGESTION:
      if (action.payload) {
        return {
          ...state,
          showErrorMessage: false,
        }
      }
      return {
        ...state,
        showErrorMessage: true,
      }

    case SET_CUSTOMER_SERVICE_TYPE:
      return {
        ...state,
        getProductsUrlStatus: ``,
        productSupportData: {},
        customerServiceType: action.payload,
      }

    case SET_CUSTOMER_CONTACT_US_METHOD:
      return {
        ...state,
        customerContactUsMethod: action.payload,
      }

    case SET_RENDER_DASHBOARD:
      return {
        ...state,
        renderDashboard: action.payload,
      }

    case RESET_MYSERVICES_DASHBOARD:
    case RESET_DASHBOARD_FROM_GETTING_STARTED:
      return {
        ...initialState,
        alertsRead: state.alertsRead,
        customerAccounts: {},
        customerAddress: state.customerAddress,
      }

    case SET_FIRST_COMPONENT_LOADED:
      return { ...state, getProductsUrlStatus: ``, productSupportData: {} }

    case GET_ALERTS_ADDRESS_PENDING:
    case GET_ALERTS_CUSTOMER_ID_PENDING:
    case GET_ALERTS_USER_ID_PENDING:
    case GET_ALERTS_ADDRESS_FAILED:
    case GET_ALERTS_CUSTOMER_ID_FAILED:
    case GET_ALERTS_USER_ID_FAILED:
      return {
        ...state,
        hasNotifications: false,
      }

    case CLEAR_GUEST_DATA:
      return {
        ...initialState,
        alertsRead: state.alertsRead,
        customerLob: state.customerLob,
        customerSelectedLob: state.customerSelectedLob,
        userProducts: state.userProducts,
        isSearchAgain: true,
      }

    case SET_IS_SEARCH_AGAIN:
      return {
        ...state,
        isSearchAgain: action.payload.isSearchAgain,
      }

    case RESET_CUSTOMER_SERVICE_TYPE:
      return {
        ...state,
        customerContactUsMethod: initialState.customerContactUsMethod,
      }

    case RESET_CUSTOMER_ADDRESS_FROM_STATE:
      return {
        ...state,
        customerAddress: {
          formattedAddress: ``,
          label: ``,
          streetNumber: ``,
          streetName: ``,
          county: ``,
          lat: null,
          lng: null,
          city: ``,
          state: ``,
          country: ``,
          postalCode: ``,
          gPlaceId: ``,
        },
        customerSearchedAddress: {
          formattedAddress: ``,
          label: ``,
          streetNumber: ``,
          streetName: ``,
          county: ``,
          lat: null,
          lng: null,
          city: ``,
          state: ``,
          country: ``,
          postalCode: ``,
          gPlaceId: ``,
        },
      }

    case SET_CUSTOMER_ACCOUNT_SOURCE:
      return {
        ...state,
        customerAccountSource: action.payload,
      }

    case SET_GUIDED_FLOW_SELECTIONS:
      return {
        ...state,
        guidedFlowSelections: {
          ...action.payload,
        },
      }

    case GET_CONTACT_BACK_ATTRIBUTES_PENDING:
      return {
        ...state,
        contactBackAttributesStatus: API_STATUSES.PENDING,
      }

    case GET_CONTACT_BACK_ATTRIBUTES_FULFILLED:
      return {
        ...state,
        contactBackAttributesStatus: API_STATUSES.FULFILLED,
        contactBackAttributesData: action.payload,
      }

    case GET_CONTACT_BACK_ATTRIBUTES_FAILED:
      return {
        ...state,
        contactBackAttributesStatus: API_STATUSES.FAILED,
      }

    case GET_GUEST_CONTAINER_REPAIR_ELIGIBILITY_PENDING:
      return {
        ...state,
        eligibilityData: {},
        getEligibilityStatus: `pending`,
      }

    case GET_GUEST_CONTAINER_REPAIR_ELIGIBILITY_FAILED:
      return {
        ...state,
        eligibilityData: action.payload,
        getEligibilityStatus: `failed`,
      }

    case GET_GUEST_CONTAINER_REPAIR_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        eligibilityData: action.payload,
        getEligibilityStatus: `fulfilled`,
      }
    case RESET_GUEST_CONTAINER_REPAIR:
      return {
        ...state,
        eligibilityData: {},
        getEligibilityStatus: ``,
      }

    case GET_ENERGY_SURCHARGE_CALCULATOR_RESULT_PENDING:
      return {
        ...state,
        energySurchargeCalculatorStatus: API_STATUSES.PENDING,
      }

    case GET_CONTACT_BACK_CASES_PENDING:
      return {
        ...state,
        contactBackCasesStatus: API_STATUSES.PENDING,
      }

    case GET_CONTACT_BACK_CASES_FULFILLED:
      return {
        ...state,
        contactBackCasesStatus: API_STATUSES.FULFILLED,
        contactBackCasesData: action.payload,
      }

    case GET_CONTACT_BACK_CASES_FAILED:
      return {
        ...state,
        contactBackCasesStatus: API_STATUSES.FAILED,
      }

    case GET_ENERGY_SURCHARGE_CALCULATOR_RESULT_FULFILLED:
      return {
        ...state,
        energySurchargeCalculatorStatus: API_STATUSES.FULFILLED,
        energySurchargeCalculatorResult: action.payload,
      }

    case GET_ENERGY_SURCHARGE_CALCULATOR_RESULT_FAILED:
      return {
        ...state,
        energySurchargeCalculatorStatus: API_STATUSES.FAILED,
      }
    case RESET_ENERGY_SURCHARGE_CALCULATOR_RESULT:
      return {
        ...state,
        energySurchargeCalculatorStatus: ``,
        energySurchargeCalculatorResult: 0,
      }

    case SET_BUISNESS_HELPMECHOOSE:
      return {
        ...state,
        helpmeChooseBusiness: action.payload,
      }

    default:
      return state
  }
}

/**
 * Checks if any customer has incidents within the last 30 days.
 * @param {Array} customers - The array of customers.
 * @returns {boolean} - Returns true if any customer has incidents within the last 30 days, otherwise false.
 */
export const getWithin30Days = (customers) =>
  customers.some((customer) =>
    customer.incidents.some((incident) => {
      const incidentDate = dayjs(incident.date)
      const date30DaysAgo = dayjs().subtract(30, "days")

      return incidentDate.isAfter(date30DaysAgo)
    }),
  )
